/* eslint-disable no-undef */
/* eslint-disable no-console */

import "slick-carousel"; // registers $.fn.slick

(function ($) {

	// Global Window Object

	// let width = window.innerWidth; // Use Web API.
	// let height = window.innerHeight; // Use Web API.

	// Global Window Object

	$(function () {

		// console.log("Width: " + width + ", Height: " + height);

		/**
		 * Removes WordPress's default navigation handlers
		 * Implements a clean toggle to open/close the menu with the hamburger button.
		 * Wait a bit for WordPress navigation to initialize, then replace the button with a clone that has no event handlers, and add our own click handler to toggle the menu.
		 * This ensures the menu opens and closes properly without interference from WordPress's default behavior, which can cause issues with the menu getting stuck open or not closing correctly.
		 * The menu will also close when clicking the button again, providing a better user experience on mobile devices.
		 */
		setTimeout(function() {
			const $menuButton = $('.wp-block-navigation__responsive-container-open');
			const $menuContainer = $('.wp-block-navigation__responsive-container');

			if ($menuButton.length && $menuContainer.length) {
				// Clone the button to remove all existing event handlers
				const newButton = $menuButton[0].cloneNode(true);
				$menuButton[0].parentNode.replaceChild(newButton, $menuButton[0]);

				// Add our toggle handler to the new button
				$(newButton).on('click', function(e) {
					e.preventDefault();
					e.stopPropagation();

					// Toggle the menu open/closed
					if ($menuContainer.hasClass('is-menu-open')) {
						// Close menu and all submenus
						closeAllSubmenus();
						$menuContainer.removeClass('is-menu-open has-modal-open');
						$(this).attr('aria-expanded', 'false');
						$('body').removeClass('has-modal-open');
					} else {
						// Open menu
						$menuContainer.addClass('is-menu-open has-modal-open');
						$(this).attr('aria-expanded', 'true');
						$('body').addClass('has-modal-open');
					}
				});
			}

			// Handle submenu toggles at all levels
			const $submenuToggles = $('.wp-block-navigation-submenu__toggle');

			$submenuToggles.each(function() {
				const originalToggle = $(this)[0];
				const newToggle = originalToggle.cloneNode(true);
				originalToggle.parentNode.replaceChild(newToggle, originalToggle);

				$(newToggle).on('click', function(e) {
					e.preventDefault();
					e.stopPropagation();

					const $toggle = $(this);
					const $parentItem = $toggle.closest('.wp-block-navigation-submenu');
					const $submenu = $toggle.siblings('.wp-block-navigation__submenu-container');
					const isOpen = $toggle.attr('aria-expanded') === 'true';

					if (isOpen) {
						// Close this submenu and all its children
						closeSubmenuAndChildren($submenu);
						$toggle.attr('aria-expanded', 'false');
					} else {
						// Close sibling submenus only (not parent or child submenus)
						closeSiblingSubmenus($parentItem);

						// Open this submenu
						$submenu.addClass('is-open');
						$toggle.attr('aria-expanded', 'true');
					}
				});
			});

			// Function to close all submenus (used when closing main menu)
			function closeAllSubmenus() {
				$('.wp-block-navigation__submenu-container').removeClass('is-open');
				$('.wp-block-navigation-submenu__toggle').attr('aria-expanded', 'false');
			}

			// Function to close only sibling submenus at the same level
			function closeSiblingSubmenus($parentItem) {
				// Find siblings that have submenus
				$parentItem.siblings('.wp-block-navigation-submenu').each(function() {
					const $siblingSubmenu = $(this).find('> .wp-block-navigation__submenu-container');
					const $siblingToggle = $(this).find('> .wp-block-navigation-submenu__toggle');

					// Close the sibling and all its children
					closeSubmenuAndChildren($siblingSubmenu);
					$siblingToggle.attr('aria-expanded', 'false');
				});
			}

			// Function to close a submenu and all nested children
			function closeSubmenuAndChildren($submenu) {
				$submenu.removeClass('is-open');
				// Close all nested submenus within this submenu
				$submenu.find('.wp-block-navigation__submenu-container').removeClass('is-open');
				$submenu.find('.wp-block-navigation-submenu__toggle').attr('aria-expanded', 'false');
			}
			// ESC key handler — close the deepest open submenu first, then mobile menu
			$(document).on('keydown', function(e) {
				if (e.key !== 'Escape') return;

				// Find the deepest open submenu
				const $openSubmenus = $('.wp-block-navigation__submenu-container.is-open');
				if ($openSubmenus.length) {
					const $deepest = $openSubmenus.last();
					const $toggle = $deepest.siblings('.wp-block-navigation-submenu__toggle');

					closeSubmenuAndChildren($deepest);
					$toggle.attr('aria-expanded', 'false');
					$toggle.trigger('focus');

					e.preventDefault();
					return;
				}

				// No submenus open — check if mobile menu is open
				if ($menuContainer.hasClass('is-menu-open')) {
					closeAllSubmenus();
					$menuContainer.removeClass('is-menu-open has-modal-open');
					$('body').removeClass('has-modal-open');

					const $openButton = $('.wp-block-navigation__responsive-container-open');
					$openButton.attr('aria-expanded', 'false');
					$openButton.trigger('focus');

					e.preventDefault();
				}
			});

		}, 100);
		/** */

		if ($('.team-carousel').length > 0) {

			const $slider = $(".team-carousel");

			if ($slider.length && !$slider.hasClass("slick-initialized")) {
				$slider.slick({
					slidesToShow: 4,
					slidesToScroll: 1,
					infinite: true,
					autoplay: true,
					autoplaySpeed: 3000,
					arrows: true,
					dots: false,
					adaptiveHeight: false,
					responsive: [
						{ breakpoint: 1200, settings: { slidesToShow: 3 } },
						{ breakpoint: 992, settings: { slidesToShow: 2 } },
						{ breakpoint: 600, settings: { slidesToShow: 1 } },
					],
				});
			}

		}

		if ($('.faculty-carousel').length > 0) {

			const $slider = $(".faculty-carousel");

			if ($slider.length && !$slider.hasClass("slick-initialized")) {
				$slider.slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					autoplay: true,
					autoplaySpeed: 3000,
					arrows: false,
					dots: true,
					adaptiveHeight: false,
					responsive: [
						{ breakpoint: 992, settings: { slidesToShow: 2 } },
						{ breakpoint: 600, settings: { slidesToShow: 1 } },
					],
				});
			}

		}

		if ($('.hero-carousel').length > 0) {

			const $slider = $(".hero-carousel");

			if ($slider.length && !$slider.hasClass("slick-initialized")) {
				$slider.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					autoplay: true,
					autoplaySpeed: 3000,
					arrows: false,
					dots: true,
					adaptiveHeight: false
				});
			}

		}

	});

	$(window).on('load', function () {

	});

})(jQuery);
